import { Account } from "@bn/api/apiv1";
import { useMemo } from "react";
import { Account as OldAccount } from "@api/v1";

interface GroupedIdsByType {
  depotIds: number[];
  cashIds: number[];
  creditCardIds: number[];
}

export const useAccountIdsByTypes = (
  accounts: (Account | OldAccount)[] = []
): GroupedIdsByType => {
  return useMemo(
    () =>
      accounts.reduce(
        (acc, val) => {
          if (val.typeFromBank === "CREDIT_CARD") {
            return { ...acc, creditCardIds: [...acc.creditCardIds, val.id] };
          }
          if (val.type === "01_depot" || val.type === "05_material_assets") {
            return { ...acc, depotIds: [...acc.depotIds, val.id] };
          }
          if (val.type === "02_cash") {
            return { ...acc, cashIds: [...acc.cashIds, val.id] };
          }

          return acc;
        },
        {
          depotIds: [],
          cashIds: [],
          creditCardIds: [],
        } as GroupedIdsByType
      ),
    [accounts]
  );
};
